<template>
  <pop-box class="updateBox" ref="updateBox" title="修改用户密码" :width="500" hasNotButton="true" @closeDialog="closeFun">
    <el-form ref="myForm" :model="formData" :rules="rules">
      <el-form-item label="原始密码：" prop="UserPwd">
        <el-input type="password" v-model="formData.UserPwd"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newUserPwd" >
        <el-input type="password" v-model="formData.newUserPwd"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPassword" >
        <el-input type="password" v-model="formData.confirmPassword"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <button class="btnx-normal btn-blue" @click="updatePassword">确定</button>
      <button class="btnx-normal btn-gray" @click="clearPassword">清除</button>
    </div>
  </pop-box>
</template>

<script>
  import {postAction} from '@/service/http/api'
  import des from '@/service/des'
  import formRules from "@/service/formRules"
export default {
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formData.confirmPassword) {
          this.$refs.myForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formData.newUserPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      formData:{
        UserName:null,
        UserPwd:null,
        newUserPwd:null,
				confirmPassword:null
			},
      rules:{
        UserPwd:[
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newUserPwd:[
          { validator: validatePass, trigger: 'blur' },
          formRules.pwd
        ],
        confirmPassword:[
          { validator: validatePass2, trigger: 'blur' }
        ],
      }
    }
  },
  methods:{
    /**修改密码 */
    updatePassword(){
      console.log('111');
      try{
        this.$refs.myForm.validate((valid) => {
          console.log('222');
          if (valid) {
            console.log('333');
            let para = new FormData();
            para.append('UserName',localStorage.getItem('userName'));
            para.append('UserPwd',des.des_encrypt(this.formData.UserPwd));
            para.append('newUserPwd',des.des_encrypt(this.formData.newUserPwd));
            postAction('/login/pwdModify',para).then( res => {
              if(res.code === 200){
                this.$message({
                  message: "修改成功,请重新登录",
                  type: "success"
                });
                localStorage.clear();
                this.$router.push("/login");
              }
            })
          }
        });
      }catch (e) {
        console.error(e);
      }
    },
    clearPassword(){
       Object.keys(this.formData).forEach(key => {
        this.formData[key] = "";
       })
    },
    closeFun(){
      this.$refs.updateBox.isVisible = false;
      this.$emit('close')
    }
  },
  mounted(){
    this.$refs.updateBox.isVisible = true;
  }
}
</script>

<style lang="scss">
  .updateBox .el-input input{
    width: 200px!important;
  }
  .updateBox .updateBtn{
    text-align: center;
    margin-top:40px;
  }
  .updateBox.pop-box .el-dialog{
    position: fixed;
    top:50%;
    left: 50%;
    margin-left: -200px!important;
    margin-top:-165px!important;
	}
	.userTab.el-dropdown-menu{
		top:30px!important;
	}
</style>




// WEBPACK FOOTER //
// src/components/basics/updatePassword.vue